/* Update the bundle product thumbnails from the selected Bundle option. */
(function(){
  const update = function(){
    document.querySelectorAll('.wg-princia-product').forEach(function(root){
      const selected=root.querySelector('variant-selects input[type="radio"][name="Bundle"]:checked');
      const count=Math.max(1,Math.min(3,parseInt(selected?.value||'1',10)||1));
      root.querySelectorAll('[data-wg-image-tier]').forEach(function(node){
        node.classList.toggle('wg-bundle-photo-selected',Number(node.dataset.wgImageTier)===count);
      });
    });
  };
  document.addEventListener('change',function(e){if(e.target.closest('.wg-princia-product variant-selects'))update()});
  document.addEventListener('DOMContentLoaded',update);
  document.addEventListener('shopify:section:load',update);
  if(document.readyState!=='loading')update();
})();

/* Shopify-backed per-kit colors: each circle chooses a real SKU variant. */
(function(){
  const mount = function(root){
    const panel=root.querySelector('[data-wg-color-panel]');
    if(!panel||panel.dataset.wgReady==='true')return;
    const selects=panel.closest('variant-selects');
    if(!selects)return;
    const comboInputs=Array.from(selects.querySelectorAll('input[type="radio"][name="Color combination"]'));
    const bundleInputs=Array.from(selects.querySelectorAll('input[type="radio"][name="Bundle"]'));
    if(!comboInputs.length||!bundleInputs.length)return;
    panel.dataset.wgReady='true';
    const state=['Red','Red','Red'];
    const initial=comboInputs.find(r=>r.checked);
    if(initial){initial.value.split(' + ').forEach((v,i)=>{if(i<3)state[i]=v;});}
    const count=()=>{
      const choice=bundleInputs.find(r=>r.checked);
      return Math.max(1,Math.min(3,Number.parseInt(choice?.value||'1',10)||1));
    };
    const placeUnderActiveBundle=()=>{
      const checked=bundleInputs.find(input=>input.checked);
      const label=checked?.nextElementSibling;
      if(label&&label.tagName==='LABEL'){
        label.insertAdjacentElement('afterend',panel);
        panel.classList.add('wg-inline-under-bundle');
      }
    };
    const render=()=>{
      placeUnderActiveBundle();
      const kits=count();
      panel.querySelectorAll('[data-wg-kit-row]').forEach(row=>{
        row.hidden=Number(row.dataset.wgKitRow)>kits;
      });
      panel.querySelectorAll('[data-wg-color-display]').forEach(el=>{
        el.textContent=state[Number(el.dataset.wgColorDisplay)-1]||'Red';
      });
      panel.querySelectorAll('.wg-color-swatch').forEach(button=>{
        button.setAttribute('aria-pressed',String(state[Number(button.dataset.wgKit)-1]===button.dataset.wgColor));
      });
    };
    const chooseActualVariant=()=>{
      const val=state.slice(0,count()).join(' + ');
      const radio=comboInputs.find(x=>x.value===val && !x.disabled);
      if(radio && !radio.checked){radio.click();}
    };
    panel.querySelectorAll('.wg-color-swatch').forEach(b=>{
      b.addEventListener('click',()=>{
        state[Number(b.dataset.wgKit)-1]=b.dataset.wgColor;
        render();
        chooseActualVariant();
      });
    });
    bundleInputs.forEach(r=>r.addEventListener('change',()=>{
      render();
      chooseActualVariant();
    }));
    comboInputs.forEach(r=>r.addEventListener('change',()=>{
      if(!r.checked)return;
      const names=r.value.split(' + ');
      names.forEach((name,i)=>{if(i<3)state[i]=name;});
      render();
    }));
    render();
    chooseActualVariant();
  };
  const boot=()=>{document.querySelectorAll('.wg-princia-product').forEach(mount);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

(function(){
  function init(root){
    const fieldset=root.querySelector('[data-wg-aura-upgrade]');
    const form=root.querySelector('product-form.main-product-form form[data-type="add-to-cart-form"]');
    if(!fieldset || !form || fieldset.dataset.initialized==='true')return;
    fieldset.dataset.initialized='true';
    const stripeChoice=fieldset.querySelector('input[value="stripe"]');
    const addOnId=Number(fieldset.dataset.addOnVariant||0);
    const addOnReady=fieldset.dataset.addOnReady==='true'&&addOnId>0;
    const payButtons=root.querySelectorAll('.shopify-payment-button');
    const error=fieldset.querySelector('.wg-aura-error');
    function update(){
      const selected=!!stripeChoice?.checked && addOnReady;
      fieldset.classList.toggle('wg-aura-checked-stripe',selected);
      payButtons.forEach(n=>{n.hidden=selected;});
      if(error){error.hidden=true;error.textContent='';}
    }
    fieldset.addEventListener('change',update);
    form.addEventListener('submit',async function(e){
      if(!stripeChoice?.checked || !addOnReady)return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const submitter=form.querySelector('[type="submit"][name="add"]');
      if(submitter?.disabled || submitter?.getAttribute('aria-disabled')==='true')return;
      const data=new FormData(form);
      const productId=Number(data.get('id'));
      const quantity=Math.max(1,parseInt(String(data.get('quantity')||'1'),10)||1);
      if(!productId)return;
      const wings={id:productId,quantity};
      const props={};
      for(const [name,val] of data.entries()){
        const m=name.match(/^properties\[([^\]]+)\]$/);
        if(m&&typeof val==='string')props[m[1]]=val;
      }
      if(Object.keys(props).length)wings.properties=props;
      const plan=data.get('selling_plan');
      if(plan)wings.selling_plan=Number(plan);
      const cart=document.querySelector('cart-notification')||document.querySelector('cart-drawer');
      const sectionIds=cart?.getSectionsToRender().map(section=>section.id)||[];
      const payload={items:[wings,{id:addOnId,quantity:1}]};
      if(sectionIds.length){
        payload.sections=sectionIds;
        payload.sections_url=window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }
      let added=false;
      if(submitter){
        submitter.disabled=true;
        submitter.setAttribute('aria-disabled','true');
        submitter.classList.add('loading');
      }
      try{
        const rootPath=window.Shopify?.routes?.root||'/';
        const response=await fetch(rootPath+'cart/add.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          credentials:'same-origin',
          body:JSON.stringify(payload)
        });
        if(!response.ok){
          const body=await response.json().catch(()=>({}));
          throw Error(body?.description||'Unable to add both items to the cart.');
        }
        const result=await response.json();
        added=true;
        if(cart){
          if(sectionIds.some(id=>!result.sections?.[id])){
            const refreshed=await fetch(rootPath+'?sections='+encodeURIComponent(sectionIds.join(',')),{credentials:'same-origin'});
            if(!refreshed.ok)throw Error('Unable to refresh the cart.');
            result.sections=await refreshed.json();
            if(sectionIds.some(id=>!result.sections?.[id]))throw Error('Unable to render the cart.');
          }
          cart.classList.remove('is-empty');
          if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'product-form'});
          cart.renderContents(result);
        }else{
          window.location.assign(window.routes?.cart_url||rootPath+'cart');
        }
      }catch(err){
        if(error){
          error.hidden=false;
          error.textContent=added?'Your items were added. Please open the cart using the cart icon.':'The LED Stripe could not be added. Please try again or choose the Wing Projector Only.';
        }
      }finally{
        if(submitter){
          submitter.disabled=false;
          submitter.removeAttribute('aria-disabled');
          submitter.classList.remove('loading');
        }
      }
    },true);
    update();
  }
  function start(){document.querySelectorAll('.wg-princia-product').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

